import { Injectable } from '@angular/core';

import { type SchedulesHostGrouping, SchedulesRouteBuilder } from '@efficiently/client-api-schedules';
import { PROJECT_DETAIL_ROUTES, SCHEDULES_ROUTES } from '@efficiently/client-core-routing';

/**
 * The schedule URLs of the Design host — the project-detail tab the schedule has always been mounted in.
 *
 * Provided at the application root in `createAppConfig`, so it is what every reader of
 * `SchedulesRouteBuilder` gets unless a host overrides the class on its own route.
 */
@Injectable()
export class DesignSchedulesRouteBuilder extends SchedulesRouteBuilder {
	public override view(projectShortId: string, grouping: SchedulesHostGrouping, view: string): string {
		// Exhaustive over `SchedulesHostGrouping`: a grouping added to the union stops compiling here,
		// because `noImplicitReturns` leaves this method without an ending return.
		switch (grouping) {
			case 'rooms':
				return SCHEDULES_ROUTES.ROOMS.fullPath(projectShortId, view);
			case 'item-ids':
				return SCHEDULES_ROUTES.ITEM_IDS.fullPath(projectShortId, view);
		}
	}

	public override isOnSchedule(url: string, projectShortId: string): boolean {
		return url.includes(PROJECT_DETAIL_ROUTES.SCHEDULES.path) && url.includes(projectShortId);
	}
}
